<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msg" :mensagem="msg" />


    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item">
                <TpProducaoSelect :tpProdutoMapa="globalStore.atividade.tpproduto_mapa" v-model:idSelecionado="idTpProducao" />
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Quantidade Diária</label>
                <input type="text" class="input-right" v-model="edQuantidade" v-decimal-mask />
            </div>
            
            <div class="form-item-char10">
                <UnidadeMedidaSelect v-model:unidadeSelecionada="unidadeSelecionada" />
            </div>

            <button class="btn-confirm" @click="salvarItem">Salvar Ítem</button>
            <button @click="closeForm">Sair</button>
        </div>
    </div>


    <div v-if="lsDados.length>0" class="table-wrapper">
        <table>
            <thead><tr>
                <th>Tipo</th>
                <th>Quantidade Diária</th>
                <th>Unidade</th>
                <th>Data registro</th>
                <th></th>
            </tr></thead>
            
            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                    <td>{{ obj.nmtpproducao }}</td>
                    <td class="col-width-char20 right">{{ Funcoes.formatDecimal(obj.qtddiaria) }}</td>
                    <td class="col-width-char20 center">{{ obj.unidade }}</td>
                    <td class="col-width-char20 center">{{ Funcoes.formatDateTimeFromJson(obj.dataupd) }}</td>
                    <td class="col-width-char05"><div class="row-left">
                        <button class="btn-icon btn-icon--trash" @click="excluiItem(obj)"></button>
                    </div></td>
            </tr></tbody>
        </table>
        

        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <ConfirmModal ref="confirmModal" />
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import TpProducaoSelect from '@/components/selects/TpProducaoSelect.vue';
import UnidadeMedidaSelect from '@/selects/estaticos/UnidadeMedidaSelect.vue';

const emit = defineEmits(['close']);

const confirmModal = ref(null);
const edQuantidade = ref(null);
const msg = ref(null);
const idTpProducao = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const unidadeSelecionada = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


const closeForm = () => {emit('close');}


const excluiItem = async(item) => {
    const confirmado = await confirmModal.value.show({
        message: 'Confirma exclusão do ítem?',
        confirmText: 'Sim',
        cancelText: 'Não'
    })

    if (confirmado) {
        try{
            msg.value=null;
            isLoading.value=true;
            await Api.genericDelete({
                strparam1: 'ESTABELECIMENTOS_CPPROD', 
                intparam1: globalStore.idestabelecimento, 
                intparam2: item.idtpproducao, 
                idlogin: globalStore.idlogin,
                idusuario: globalStore.idusuario});
            await lerDados();
        } catch (error){msg.value = `ATENÇÃO: ${error.response?.data || error.message}`;
        }finally{isLoading.value=false;}
    }
}


const lerDados = async() => {
    try{
        msg.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/estabelecimentos/cpproducao', {
            idep: globalStore.idep,
            idestabelecimento: globalStore.idestabelecimento});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msg.value= error;
    } finally {isLoading.value = false;}
}


const salvarItem = async () => {
    try {
        if (!idTpProducao.value) throw new Error('Informe o tipo de produção');
        if (!edQuantidade.value) throw new Error('Informe a quantidade');
        if (!unidadeSelecionada.value) throw new Error('Informe a unidade de medida');
        isLoading.value = true;
        msg.value = null;

        const response  = await Api.genericPut('/cad/estabelecimento_cpprod', {
            idestabelecimento: globalStore.idestabelecimento,
            idtpproducao: idTpProducao.value,
            unidade: unidadeSelecionada.value,
            qtddiaria: Funcoes.decimalFromString(edQuantidade.value),
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});

        if (response.bolok === 1){
            idTpProducao.value=null;
            edQuantidade.value=null;
            lerDados();
        }else{
            msg.value=response.erro;
        }
    } catch (error){msg.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally{isLoading.value=false;}
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


onMounted(lerDados);
</script>